module.exports = __webpack_public_path__ + "assets/overlay-smile.384d45a46a2e05e52c1971c9e1f57c89.png";